/**
 * 5 Star Rating component
 *
 * @param {Function} setStarRating - change handler
 */
const StarRating = ({ starRating, setStarRating }) => (
  <div dir="rtl" className="cef-star-rating">
    <input
      id="rating_5"
      type="radio"
      name="rating"
      value="5"
      className="cef-star-rating__input cef-star-rating__input--5 hide-text"
      onChange={e => setStarRating(+e.target.value)}
      checked={starRating === 5}
    />
    <label
      htmlFor="rating_5"
      className="cef-star-rating__label"
      aria-label="5 stars"
    />
    <input
      id="rating_4"
      type="radio"
      name="rating"
      value="4"
      className="cef-star-rating__input cef-star-rating__input--4 hide-text"
      onChange={e => setStarRating(+e.target.value)}
      checked={starRating === 4}
    />
    <label
      htmlFor="rating_4"
      className="cef-star-rating__label"
      aria-label="4 stars"
    />
    <input
      id="rating_3"
      type="radio"
      name="rating"
      value="3"
      className="cef-star-rating__input cef-star-rating__input--3 hide-text"
      onChange={e => setStarRating(+e.target.value)}
      checked={starRating === 3}
    />
    <label
      htmlFor="rating_3"
      className="cef-star-rating__label"
      aria-label="3 stars"
    />
    <input
      id="rating_2"
      type="radio"
      name="rating"
      value="2"
      className="cef-star-rating__input cef-star-rating__input--2 hide-text"
      onChange={e => setStarRating(+e.target.value)}
      checked={starRating === 2}
    />
    <label
      htmlFor="rating_2"
      className="cef-star-rating__label"
      aria-label="2 stars"
    />
    <input
      id="rating_1"
      type="radio"
      name="rating"
      value="1"
      className="cef-star-rating__input cef-star-rating__input--1 hide-text"
      onChange={e => setStarRating(+e.target.value)}
      checked={starRating === 1}
    />
    <label
      htmlFor="rating_1"
      className="cef-star-rating__label"
      aria-label="1 star"
    />
  </div>
);

export default StarRating;
